import {
	TREE_BLOCK,
	treeBodyToHtml,
} from "@productlane/lib/src/tiptap/extensions/mintlify/tree-html"

import type { MdxBlockReader } from "./registry"

export const treeReaders: MdxBlockReader[] = [
	{
		name: "tree",
		pattern: new RegExp(TREE_BLOCK.source, "g"),
		// A tree with neither tags nor a list is left as the markdown it holds.
		render: (match, parseBody) =>
			treeBodyToHtml(match[3] ?? "") ?? parseBody(match[3] ?? ""),
	},
]
